import {z} from 'zod';

import {InventoryValueQuerySchema} from '@prompt-bridge/shared/validations';

import {getSafely} from 'shared/web';

type InventoryValueQueryInput = z.input<typeof InventoryValueQuerySchema>;

const toValues = (value: string | string[] | undefined) => {
  if (value === undefined) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

/**
 * Serializes the inventory-value filters as repeated query parameters. `fetchBaseQuery` has no
 * `paramsSerializer`, so handing it a `string[]` would comma-join the values into a single bogus
 * identifier — every multi-select filter has to be appended one element at a time.
 */
export function inventoryValueSearchParams(filters: InventoryValueQueryInput) {
  const params = new URLSearchParams();
  if (filters.asOf !== undefined) {
    params.append('asOf', filters.asOf);
  }
  for (const key of ['warehouse', 'branch'] as const) {
    for (const value of toValues(getSafely(filters, key))) {
      params.append(key, value);
    }
  }
  if (filters.months !== undefined) {
    params.append('months', String(filters.months));
  }
  return params.toString();
}
